import jwt from '@src/auth/jwt/useJwt'

export const getUserServicesApi = async ({ userId, meliUserId }) => {
  try {
    const response = await jwt.get(
      `user/meli/${meliUserId}/services`,
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    const err = new Error(`Error al obtener servicios: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const getSalesPreviewApi = async ({ userId, meliUserId }) => {
  try {
    const response = await jwt.get(
      `user/meli/${meliUserId}/mp-subscription/sales-preview`,
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    const err = new Error(`Error al obtener preview de ventas: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const getMpSubscriptionApi = async ({ userId, meliUserId }) => {
  try {
    const response = await jwt.get(
      `user/meli/${meliUserId}/mp-subscription`,
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 404) {
      const err = new Error('not_found')
      err.type = 'NOT_FOUND'
      throw err
    }
    const err = new Error(`Error al obtener la suscripción: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const initiatePaymentApi = async ({ userId, meliUserId, paymentMode, months }) => {
  try {
    const body = paymentMode === 'subscription' ? { paymentMode: 'subscription' } : { paymentMode: 'one_time', months }

    const response = await jwt.post(
      `user/meli/${meliUserId}/mp-subscription/initiate`,
      body,
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status

    if (error?.response?.data?.code === 'mp_subscription_no_services_exception') {
      const err = new Error('Necesitás adherirte a un servicio antes de suscribirte a MercadoPago.')
      err.type = 'NO_SERVICES'
      throw err
    }

    if (status === 400) {
      const err = new Error('Datos inválidos. Intentá de nuevo.')
      err.type = 'BAD_REQUEST'
      throw err
    }

    if (status === 409) {
      const err = new Error('Ya tenés una suscripción activa.')
      err.type = 'CONFLICT'
      throw err
    }

    const err = new Error(`Error al iniciar el pago: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const activateServiceApi = async ({ userId, meliUserId, serviceType }) => {
  try {
    const response = await jwt.post(
      `user/meli/${meliUserId}/services/${serviceType}/activate`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status

    if (status === 409) {
      const err = new Error('Este servicio ya está activo en tu cuenta.')
      err.type = 'CONFLICT'
      throw err
    }

    if (status === 402) {
      const err = new Error('Tu período de prueba ya fue utilizado. Contactá soporte para contratar el servicio.')
      err.type = 'PAYMENT_REQUIRED'
      throw err
    }

    if (status === 400) {
      const err = new Error('Falta información requerida. Intentá cerrar sesión y volver a ingresar.')
      err.type = 'BAD_REQUEST'
      throw err
    }

    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const deactivateServiceApi = async ({ userId, meliUserId, serviceType }) => {
  try {
    const response = await jwt.post(
      `user/meli/${meliUserId}/services/${serviceType}/deactivate`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status

    // 409 = idempotente (ya estaba inactive/expired) → tratar como éxito silencioso
    if (status === 409) {
      return { idempotent: true }
    }

    if (status === 404) {
      const err = new Error('El servicio no existe en esta cuenta.')
      err.type = 'NOT_FOUND'
      throw err
    }

    const err = new Error(`Error al pausar el servicio: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const reactivateServiceApi = async ({ userId, meliUserId, serviceType }) => {
  try {
    const response = await jwt.post(
      `user/meli/${meliUserId}/services/${serviceType}/reactivate`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status

    if (status === 402) {
      const err = new Error('Necesitás una suscripción activa para reactivar este servicio.')
      err.type = 'PAYMENT_REQUIRED'
      throw err
    }

    // 409 = idempotente (ya estaba trial/active/pending_payment) → éxito silencioso
    if (status === 409) {
      return { idempotent: true }
    }

    if (status === 404) {
      const err = new Error('El servicio nunca fue activado. Primero activalo.')
      err.type = 'NOT_FOUND'
      throw err
    }

    const err = new Error(`Error al reactivar el servicio: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}
